// Used to map boompay mobile screen names to enrollment routes

export const issueScreenMap: {
  [key: string]: string;
} = {
  Plaid: "/settings/linked-accounts",
  BF20UpdatePayment: "/404", // dont have add payment screen yet
  BFLandlordIssue: "/404", // dont have add landlord issue screen yet
  BF18LeaseClose: "/rent_reporting/:id/issues/m-2-m/lease-end", // works for both lease-end and m2m
  BF12UploadLease: "/rent_reporting/onboarding/lease_upload",
  BFPaymentVerifications: "/rent_reporting/issues/verify-rent", // dont have add payment verification screen yet
  BF05PortalUnlisted: "/404" // dont have add portal unlisted screen yet
};
